var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEsgCalender(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.16667 17.3337C1.70833 17.3337 1.31597 17.1705 0.989583 16.8441C0.663194 16.5177 0.5 16.1253 0.5 15.667V4.00033C0.5 3.54199 0.663194 3.14963 0.989583 2.82324C1.31597 2.49685 1.70833 2.33366 2.16667 2.33366H3V0.666992H4.66667V2.33366H11.3333V0.666992H13V2.33366H13.8333C14.2917 2.33366 14.684 2.49685 15.0104 2.82324C15.3368 3.14963 15.5 3.54199 15.5 4.00033V15.667C15.5 16.1253 15.3368 16.5177 15.0104 16.8441C14.684 17.1705 14.2917 17.3337 13.8333 17.3337H2.16667ZM2.16667 15.667H13.8333V7.33366H2.16667V15.667ZM2.16667 5.66699H13.8333V4.00033H2.16667V5.66699Z",
    fill: "#054254"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsgCalender);
export default __webpack_public_path__ + "static/media/Esg-Calender.72065adf1f7030cd9065988f73d18ed5.svg";
export { ForwardRef as ReactComponent };